import { AiQueryFragment } from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import { atom, selectorFamily } from 'recoil';
import { AsyncLoadStatus } from '../../common/types';
import {
  AiAgentContextType,
  AiAgentMessageLog,
  AiAgentMessageLogState,
} from './aiAgent.types';

const getKey = (postfix: string) => `warebee-ai-agent-${postfix}`;

export const aiAgentContextType = atom<AiAgentContextType>({
  key: getKey('context-type'),
  default: null,
});

export const aiAgentMessageLogs = atom<Record<string, AiAgentMessageLog>>({
  key: getKey('message-logs-all'),
  default: {},
});

export const aiAgentQueries = atom<AiAgentMessageLog>({
  key: getKey('message-log-current'),
  default: [],
  // get: ({ get }) => {
  //   const whId = get(warehouseSelectedId);
  //   return get(aiAgentMessageLogs)[whId] ?? [];
  // },
  // set: ({ get, set }, value: AiAgentMessageLog) => {
  //   const whId = get(warehouseSelectedId);
  //   set(aiAgentMessageLogs, current => ({ ...current, [whId]: value }));
  // },
});
export const aiAgentQueriesState = atom<AiAgentMessageLogState>({
  key: getKey('message-log-load-state'),
  default: null,
});

export const aiAgentQueriesLoadStatus = atom<AsyncLoadStatus>({
  key: getKey('message-logs-all-status'),
  default: AsyncLoadStatus.None,
});

export const aiAgentMessageById = selectorFamily<AiQueryFragment, string>({
  key: getKey('message-by-id'),
  get:
    (messageId: string) =>
    ({ get }) => {
      return _.find(get(aiAgentQueries), m => m.id === messageId);
    },
  set:
    (messageId: string) =>
    ({ get, set }, value: AiQueryFragment) => {
      const messages = get(aiAgentQueries);
      const current = _.find(messages, m => m.id === messageId);
      const others = _.filter(messages, m => m.id !== messageId);

      set(aiAgentQueries, [...others, { ...current, ...value }]);
    },
});
